import { useContext, useState } from "react";
import axios from "@fetch/axios"
import { useTranslation } from "@hooks/useTranslation";
import { LanguageCurrencyContext } from "@context/LanguageCurrencyContext";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import Spinner from "@components/Spinner";

const Component = () => {
  const MySwal = withReactContent(Swal)
  const { translate } = useTranslation();
  const token_recuperar_clave = localStorage.getItem("token_recuperar_clave");
  const token_email = localStorage.getItem("token_email");
  const { lang } = useContext(LanguageCurrencyContext);
  const [loading, setLoading] = useState(true)

  const reenviar = async (type = 1) => {
    setLoading(false);
    try {
      const res = await axios.put(
        "/users/resend-password-recovery",
        {
          "token": token_recuperar_clave,
          "type": type,
          "lang": lang
        }
      );
      setLoading(true);
      if (res.data.errors) {
        MySwal.fire({
          text: res.data.message,
          icon: 'error',
          title: 'Oops...'
        })
      } else {
        localStorage.setItem('token_recuperar_clave', res.data.token);
        MySwal.fire({
          text: translate('login.resend'),
          icon: 'success',
        })

      }
    } catch (error) {
      setLoading(true);
      MySwal.fire({
        text: error.response.data,
        icon: 'error',
        title: 'Oops...'
      })

    }
  }

  return (
    <>
      {!loading && <Spinner />}
      <div className="icon-Mail IconLarge"></div>
      <div className="TextLeft">
        <p>
          {translate('confirmation.send1')} {token_email}, {translate('confirmation.send8')}
        </p>
        <p>
          {translate('confirmation.send9')}
        </p>
      </div>
      <div>
        <p>{translate('confirmation.send10')} </p>
        <b onClick={() => { reenviar(1) }}>{translate('confirmation.send11')}</b>
      </div>
      <div>
        <b onClick={() => { reenviar(2) }}>{translate('confirmation.send12')}</b>
      </div>
    </>
  );
};

export default Component;
